import React, { useRef } from "react";
import { injectIntl } from "react-intl";

function BranchFilters({intl, searchParams, regionList, specialismOptions, appConfigs, resultsTotal}) {
  const filtersPopup = useRef();

  return (
    <>
      <div className="filter" data-rs-filter={true}>
        <div className="filter__box hidden">
          <div className="filter__toggle" data-rs-filter-refine-search={true} role="button" aria-label="">
            <span className="icon icon--inline hidden--from-l text-brand-primary">
                <svg>
                  <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#filter"/>
                </svg>
            </span>
            <span>{ intl.formatMessage({id: "BranchFilters.FilterTitle"}) }</span>
          </div>
          <div className="filter__content" data-rs-filter-content={true} ref={filtersPopup}>
              <div className="filter__header hidden--from-l">
                  <div className="filter__title">
                      { intl.formatMessage({id: "BranchFilters.FilterTitleMobile"})}
                  </div>
                  <span className="icon icon--inline">
                      <svg data-rs-filter-close={true}>
                        <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#close"/>
                      </svg>
                  </span>
              </div>
          </div>
        </div>
        <div className="seo-content text--alternative">
          { appConfigs && appConfigs.text_below_filters ? appConfigs.text_below_filters : intl.formatMessage({id: "BranchFilters.SeoText"}) }
        </div>
      </div>
    </>
  )
}

export default injectIntl(BranchFilters);